/** @format */
/****************************************************************************************
 * Responsibility - Renders the layout for the reorders and orders page
 * *********************************************************************
 */

import {GroupedByOrderList} from './designs_grouped_table/grouped_by_order_list';
import DesignListUngrouped from './designs_ungrouped_table/design_list_ungrouped';
import useGroupedbyOrder from '../shared/use_grouped_by_order';
import {withSearch, SearchContext} from 'frontier-search';
import {IfElse, withRouter} from 'frontier-utilities';
import {SearchWithContext} from '../search/search';
import React, {useContext, useEffect} from 'react';
import {SelectSearchBy} from '../shared/select_search_by';

// styles
import './container.scss';

export default function ReorderOrderContainer(props) {
    const ctx = useContext(SearchContext);
    const {showGroupedByOrders} = props;

    useEffect(() => {
        ctx.onSearch({});
    }, []);

    const shouldShowEmptyOrdersMessage =
        ctx.listItems?.length == 0 && !ctx.pending && ctx.search == '' && ctx.filters.length === 0;

    const shouldShowNoResultsFoundMessage =
        ctx.listItems?.length == 0 && !ctx.pending && (ctx.search != '' || ctx.filters.length > 0);
    return (
        <div className="reorders_orders-01lw">
            <IfElse condition={shouldShowEmptyOrdersMessage}>
                <div className="alert alert-info">
                    It appears you have not placed any orders with us!{' '}
                    <a href="/orders/custom-labels">Order Now!</a>
                </div>
                <IfElse condition={shouldShowNoResultsFoundMessage}>
                    <div className="alert alert-info">
                        <span>Your search returned no results.</span>
                        <button className="p-0 my-0 ms-2 d-inline-block" onClick={ctx.onReset}>
                            <u>Remove Filters</u>
                        </button>
                    </div>
                    <IfElse condition={showGroupedByOrders}>
                        <GroupedByOrderList />
                        <DesignListUngrouped />
                    </IfElse>
                </IfElse>
            </IfElse>
        </div>
    );
}
